import {Component, OnInit} from '@angular/core';

@Component({
   selector: 'app-mission',
   templateUrl: './mission.component.html',
   styleUrls: ['./mission.component.css']
})
export class MissionComponent implements OnInit {

   constructor() {
   }

   ngOnInit(): void {
      window.scrollTo(0, 0);
   }

}
